import { findSameGiftItem } from "../../../api/helpers/shoppingCartHelper";
import { couponCalculator } from "./../../../api/services/CouponCalculatorService";

const state = {
  cardSelected: undefined,
  paymentMethod: 1,
  buyFor: "",
  messageModelFromName: "",
  messageModelName: "",
  messageModelEmail: "",
  messageModelMessage: "",
  cartItems: [],
  coupons: [],
  couponStoreIds: [],
  /*OnlineOrderingModule->/store/->Menus->Loop-AllMenus->SpecialCategories->SCTypeGiftcard->SubMenuItems
    has matching product in here OnlineOrderingModule->/store/->Menus->Loop-AllMenus->Product
    Product is to store other information, giftcard should be a valid product
    */
  storeGiftCards: [],
};

export const mutations = {
  setStoreGiftCards(state, value) {
    state.storeGiftCards = value;
  },
  setPaymentMethod(state, value) {
    state.paymentMethod = value;
  },
  setBuyFor(state, value) {
    state.buyFor = value;
  },
  setCardSelected(state, value) {
    state.cardSelected = value;
  },
  setMessageModelFromName(state, value) {
    state.messageModelFromName = value;
  },
  setMessageModelName(state, value) {
    state.messageModelName = value;
  },
  setMessageModelEmail(state, value) {
    state.messageModelEmail = value;
  },
  setMessageModelMessage(state, value) {
    state.messageModelMessage = value;
  },

  /*Methods from old gift-shopping-cart */
  Add_GiftcartItem(state, { item, quantity, message }) {
    //state.cartItems = [];
    let now = new Date();
    const records = state.cartItems.filter((element) => element.id == item.id);
    let same = true;
    let find = null;
    if (records.length > 0) {
      find = findSameGiftItem(item, message, records);
      if (!find) {
        same = false;
      }
    } else {
      same = false;
    }
    if (!same) {
      state.cartItems.push({
        ...item,
        quantity,
        message,
        created: now.toUTCString(),
      });
    } else {
      find.quantity += quantity;
      find.created = new Date().toUTCString();
    }
  },
  Set_GiftItems(state, items) {
    state.cartItems = items;
  },
  REMOVE_GIFTCART_ITEM(state, { item }) {
    const record = state.cartItems.find((element) => element.id == item.id);
    state.cartItems.splice(state.cartItems.indexOf(record), 1);
  },
  UpdateGiftItemQuantity(state, { item, quantity, message }) {
    const records = state.cartItems.filter((element) => element.id == item.id);
    let same = true;
    let find = null;
    if (records.length > 0) {
      find = findSameGiftItem(item, message, records);
      if (!find) {
        same = false;
      }
      if (same) {
        find.quantity = quantity;
        if (quantity == 0) {
          state.cartItems.splice(state.cartItems.indexOf(find), 1);
        }
      }
    }
  },
  add_coupon_to_GiftCart(state, payload) {
    const { coupon, storeId } = payload;
    state.coupons.push(coupon);
    state.couponStoreIds.push(storeId);
  },
  Clear_Coupon_GiftCart_Items(state) {
    state.coupons = [];
    state.couponStoreIds = [];
  },
  remove_coupon_from_GiftCart_Cart(state, couponCode) {
    const record = state.coupons.find(
      (element) => element.CouponCode == couponCode
    );
    const index = state.coupons.indexOf(record);
    state.coupons.splice(index, 1);
    state.couponStoreIds.splice(index, 1);
  },
  remove_coupons_of_other_stores(state, storeId) {
    let index = state.coupons.length;
    while (index > -1) {
      index = state.couponStoreIds.findIndex((e) => e != storeId);
      if (index > -1) {
        state.coupons.splice(index, 1);
        state.couponStoreIds.splice(index, 1);
      }
    }
  },
};

export const actions = {
  giftFilterCoupons: ({ commit, getters }, storeId) => {
    const coupons = getters.giftCoupons;
    const storeIds = getters.getGiftCouponStoreIds;

    if (coupons.length != storeIds.length) {
      commit("Clear_Coupon_GiftCart_Items");
    }

    commit("remove_coupons_of_other_stores", storeId);
  },
  clearGiftCart: ({ commit }) => {
    commit("Set_GiftItems", []);
    commit("Clear_Coupon_GiftCart_Items");
  },
  clearGiftCoupon: ({ commit }) => {
    commit("Clear_Coupon_GiftCart_Items");
  },
  addCouponToCart: ({ commit }, payload) => {
    commit("add_coupon_to_GiftCart", payload);
  },
  removeCouponfromCart: ({ commit }, coupon) => {
    commit("remove_coupon_from_GiftCart_Cart", coupon);
  },
  resetStoreGiftCards: ({ commit }) => {
    commit("setStoreGiftCards", []);
    commit("setCardSelected", undefined);
  },
};

export const getters = {
  storeGiftCards: (state) => {
    return state.storeGiftCards;
  },
  paymentMethod: (state) => {
    return state.paymentMethod;
  },
  messageModelFromName: (state) => {
    return state.messageModelFromName;
  },
  messageModelMessage: (state) => {
    return state.messageModelMessage;
  },
  messageModelEmail: (state) => {
    return state.messageModelEmail;
  },
  messageModelName: (state) => {
    return state.messageModelName;
  },
  cardSelected: (state) => {
    return state.cardSelected;
  },
  buyFor: (state) => {
    return state.buyFor;
  },
  allGiftState: (state) => {
    return state;
  },

  /*old*/
  giftIsDelivery: (state) => {
    return state.isDelivery;
  },
  giftCartItems: (state) => {
    let copy = [...state.cartItems];
    return copy.sort((a, b) => {
      return new Date(b.created) - new Date(a.created);
    });
  },
  giftCartTotalQuantity: (state) => {
    let copy = [...state.cartItems];
    let totalQuantity = 0;
    copy.forEach((element) => {
      totalQuantity += Number(element.quantity);
    });
    return totalQuantity;
  },
  giftTotalPrice: (state, getters, rootState, rootGetters) => {
    let res = getters.giftCartValue;
    res = res + rootGetters.getGiftSurchargeAmount - getters.giftDiscount;
    return res;
  },
  giftDiscount: (state) => {
    var result = couponCalculator.calcAllCoupons(
      state.coupons,
      state.cartItems
    );
    return result;
  },
  giftUsedCoupons: (state) => {
    couponCalculator.calcAllCoupons(state.coupons, state.cartItems);
    return couponCalculator.used_Coupons;
  },
  giftCoupons: (state) => {
    return state.coupons;
  },
  getGiftCouponStoreIds: (state) => {
    return state.couponStoreIds;
  },
  giftCartValue: (state) => {
    let res = 0;
    state.cartItems.map((item) => {
      res += item.price * item.quantity;
    });
    return res;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
